import(/* webpackMode: "eager" */ "/home/runner/work/the-platform/the-platform/frontend/events-website/app/page.tsx");
